import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  left: ${spacing.majorScale(3)}px;
  margin-left: auto;
  margin-right: auto;
  max-width: 550px;
  position: absolute;
  right: ${spacing.majorScale(3)}px;
  top: calc(100% + ${spacing.majorScale(4)}px);
`
